//引入axios
import axios from 'axios'
import qs from 'qs'
import _bus from './bus'
import { Message } from 'element-ui'
import Storage from '@/utils/storage'

axios.defaults.baseURL = process.env.BASE_URL
// axios.defaults.baseURL = 'http://ucenter2.zoshang.com'
//设置默认请求头
axios.defaults.headers = {
    'X-Requested-With': 'XMLHttpRequest',
}
axios.defaults.timeout = 200000

let cancel, promiseArr = {};
const CancelToken = axios.CancelToken;

//请求拦截器
axios.interceptors.request.use(config => {
    //发起请求时，取消掉当前正在进行的相同请求
    if (promiseArr[config.url]) {
        promiseArr[config.url]('请勿重复操作')
        promiseArr[config.url] = cancel
    } else {
        promiseArr[config.url] = cancel
    }
    // 会话token
    let token = Storage.get('token');
    if (token) {
        config.headers.Authorization = token.token;
    }
    return config
}, error => {
    return Promise.reject(error)
})

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    return response
}, err => {
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                err.message = '错误请求'
                break;
            case 401:
                err.message = '未授权，请重新登录'
                break;
            case 403:
                err.message = '拒绝访问'
                break;
            case 404:
                err.message = '请求错误,未找到该资源'
                break;
            case 405:
                err.message = '请求方法未允许'
                break;
            case 408:
                err.message = '请求超时'
                break;
            case 500:
                err.message = '服务器端出错'
                break;
            case 501:
                err.message = '网络未实现'
                break;
            case 502:
                err.message = '网络错误'
                break;
            case 503:
                err.message = '服务不可用'
                break;
            case 504:
                err.message = '网络超时'
                break;
            case 505:
                err.message = 'http版本不支持该请求'
                break;
            default:
                err.message = `连接错误${err.response.status}`
        }
    } else {
        // err.message = "连接到服务器失败"
    }
    
    _bus.$emit('showloading', false);
    // Message.error(err.message);
    return Promise.reject(err)
})

let Loading_num = 0;    // loading数量

//get请求
export function $get(url, param, loading = false) {
    return new Promise((resolve) => {
        // loading
        if (loading) {
            Loading_num = Loading_num + 1;
            _bus.$emit('showloading', true);
        }
        axios({
            method: 'get',
            url,
            params: param,
            cancelToken: new CancelToken(c => {
                cancel = c
            })
        }).then(res => {
            if(loading) {
                Loading_num--
                if (Loading_num <= 0) {
                    _bus.$emit('showloading', false)
                }
            }
            resolve(res.data)
        })
    })
}
//post请求
export function $post(url, param, loading = false) {
    return new Promise((resolve) => {
        // loading
        if (loading) {
            Loading_num = Loading_num + 1;
            _bus.$emit('showloading', true)
        }
        axios({
            method: 'post',
            url,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify(param) ,
            cancelToken: new CancelToken(c => {
                cancel = c
            })
        }).then(res => {
            if (loading) {
                Loading_num--
                if (Loading_num <= 0) {
                    _bus.$emit('showloading', false)
                } else {
                    _bus.$emit('showloading', true)
                }
            }
            resolve(res.data)
        })
    })
}

// patch请求
export function $patch(url, param, loading = false) {
    return new Promise((resolve) => {
        // loading
        if (loading) {
            Loading_num = Loading_num + 1;
            _bus.$emit('showloading', true)
        }
        axios({
            method: 'patch',
            url,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify(param),
            cancelToken: new CancelToken(c => {
                cancel = c
            })
        }).then(res => {
            if (loading) {
                Loading_num--
                if (Loading_num <= 0) {
                    _bus.$emit('showloading', false)
                } else {
                    _bus.$emit('showloading', true)
                }
            }
            resolve(res.data)
        })
    })
}

// delete请求
export function $delete(url, param, loading = false) {
    return new Promise((resolve) => {
        // loading
        if (loading) {
            Loading_num = Loading_num + 1;
            _bus.$emit('showloading', true)
        }
        axios({
            method: 'delete',
            url,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: param,
            cancelToken: new CancelToken(c => {
                cancel = c
            })
        }).then(res => {
            if (loading) {
                Loading_num--
                if (Loading_num <= 0) {
                    _bus.$emit('showloading', false)
                } else {
                    _bus.$emit('showloading', true)
                }
            }
            resolve(res.data)
        })
    })
}